
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M150 112.5a75 75 0 00-150 0z","fill":"#414042"}}),_c('path',{attrs:{"d":"M75 112.5H3.68a70.92 70.92 0 019.24-35.13z","fill":"#f68c1f"}}),_c('path',{attrs:{"d":"M75 112.5L12.92 77.37a71.52 71.52 0 0126.4-26.65z","fill":"#ffcd22"}}),_c('path',{attrs:{"d":"M75 41.16v71.34L39.32 50.72A71 71 0 0175 41.16z","fill":"#42b649"}}),_c('path',{attrs:{"d":"M137 77.25L75 112.5l35.9-61.65a71.34 71.34 0 0126.1 26.4z","fill":"#3d469c"}}),_c('path',{attrs:{"d":"M146.34 112.5H75l62-35.25a71 71 0 019.34 35.25z","fill":"#652c8f"}}),_c('path',{attrs:{"d":"M110.9 50.85L75 112.5V41.16a70.9 70.9 0 0135.9 9.69z","fill":"#0ca4bd"}}),_c('path',{attrs:{"d":"M56.72 113.05a18.12 18.12 0 1136.23 0","fill":"#fff"}}),_c('path',{attrs:{"d":"M77.05 106.25v-49l-2-6.36-1.9 6.36v49a6.56 6.56 0 00-4.67 6.29h13.09a6.59 6.59 0 00-4.52-6.29z","fill":"#414042"}})])
          )
        }
      }
    